import React, { Component } from 'react';

import { Col, Row, UncontrolledCollapse, Button, Card, CardBody, CardHeader } from 'reactstrap';

import * as d3 from 'd3v4';
import styled from 'styled-components';

import Encabezado from './Encabezado';
import InfoPartido from './InfoPartido';
import InfoPais from './InfoPais';
import ViewSwitcher from './ViewSwitcher';
import svgCalendario from '../img/Cronograma.svg';

export default class VizCalendario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partido: null,
      datos: null,
      paisesSel: null,
      urlBase: props.urlBase,
      // images: null,
      atributoSeleccionado: null
    };
  }
  render() {
    const SButton = this.SButton;
    const SAccordion = this.SAccordion;
    const SAccordionItem = this.SAccordionItem;
    const SAccordionItemBody = this.SAccordionItemBody;
    const SAccordionItemTitle = this.SAccordionItemTitle;
    const SImg = this.SImg;
    const SH4 = this.SH4;
    const SIframe = this.SIframe;
    const SFixedAspectRatio = this.SFixedAspectRatio;
    const t = this.props.t;
    const i18n = this.props.i18n;
    const urlBase = this.state.urlBase;
    const datos = this.state.datos;
    if (!datos) {
      return <div />;
    }
    const maximos = datos.maximos;
    const atributos = Object.keys(maximos).map(key => {
      const atributo = {
        nombre: key,
        descripcion: t(key)
      };
      return atributo;
    });
    const paises = datos.paises;
    const partido = this.state.partido;
    const atrSel = this.state.atributoSeleccionado;
    const seasonId = '2017';
    const competition = '4';
    let timeUntilDate = null;
    if (partido) {
      timeUntilDate = partido.fecha - Date.now();
    }
    let milisDia = 24 * 60 * 60 * 1000;
    let views = [
      {
        key: 'equipos',
        name: 'Equipos',
        content: (
          <InfoPartido
            partido={partido}
            atributos={atributos}
            atributoSeleccionado={atrSel}
            onAtributoChange={this.handleAtributoChange.bind(this)}
            t={t}
            i18n={i18n}
            urlBase={urlBase}
            style={{ height: '100%', width: '100%' }}
          />
        )
      },
      {
        key: 'previa',
        name: 'Previa',
        content: partido ? (
          <iframe
            src={`https://golyfutbol.com/mundial/widget/previa/?season=${seasonId}&competition=${competition}&match=${
              partido.id
            }`}
            frameBorder="0"
            height="100%"
            style={{ height: '100%', width: '100%' }}
          />
        ) : (
          <div>{t('Seleccione un partido')}</div>
        )
      },
      {
        key: 'partido-en-vivo',
        name: 'Partido en vivo',
        content: partido ? (
          <iframe
            src={`https://golyfutbol.com/mundial/widget/partido-en-vivo/?season=${seasonId}&competition=${competition}&match=${
              partido.id
            }`}
            frameBorder="0"
            height="100%"
            style={{ height: '100%', width: '100%' }}
          />
        ) : (
          <div>{t('Seleccione un partido')}</div>
        )
      },
      {
        key: 'Formaciones',
        name: 'Formaciones',
        content: partido ? (
          <iframe
            src={`https://golyfutbol.com/mundial/widget/formaciones/?season=${seasonId}&competition=${competition}&match=${
              partido.id
            }`}
            frameBorder="0"
            height="100%"
            style={{ height: '100%', width: '100%' }}
          />
        ) : (
          <div>{t('Seleccione un partido')}</div>
        )
      },
      {
        key: 'comparacion-jugadores',
        name: 'Comparación de jugadores',
        content: partido ? (
          <iframe
            src={`https://golyfutbol.com/mundial/widget/comparacion-jugadores/?season=${seasonId}&competition=${competition}&match=${
              partido.id
            }`}
            frameBorder="0"
            height="100%"
            style={{ height: '100%', width: '100%' }}
          />
        ) : (
          <div>{t('Seleccione un partido')}</div>
        )
      }
    ];
    return (
      // <div className="container">
      <div style={{ width: '100%', overflow: 'hidden' }}>
        {/* <Row style={{ height: '90vh' }}> */}
        <Row>
          <Col xs={12} md={8}>
            <SH4>{t('Seleccione un partido')}:</SH4>
            <SFixedAspectRatio>
              <SIframe
                id="calendario-gyf"
                src="https://widgets.golyfutbol.com/svg-preprocess/"
                // src="http://localhost:5000"
                // src="http://192.168.0.7:5000"
                frameBorder="0"
              />
            </SFixedAspectRatio>
          </Col>
          <Col xs={12} md={4}>
            <ViewSwitcher
              style={{ width: '100%', height: '100%', minHeight: '90vh' }}
              selectedKey="equipos"
              views={partido && timeUntilDate ? (
                timeUntilDate <= 0 ?
                  views
                  : (timeUntilDate <= 3 * milisDia ?
                    views.filter(view => view.key === 'equipos' || view.key === 'previa')
                    : views.filter(view => view.key === 'equipos')
                  )
              ) : views.filter(view => view.key === 'equipos')}
            />
          </Col>
        </Row>
      </div>
      // </div>
    );
  }
  componentDidMount() {
    this.handleUrlUpdate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.urlBase !== prevState.urlBase) {
      this.handleUrlUpdate();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ urlBase: nextProps.urlBase });
  }

  SImg = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
  `;

  // preloadImages(urlBase, datos) {
  //   console.log('preloading');
  //   let images = datos.paises.map((pais, i) => {
  //     let img = new Image();
  //     img.src = `${urlBase}/img/banderas/${pais.iso_code}.svg`;
  //     return img;
  //   });
  //   images.concat(
  //     datos.paises.map((pais, i) => {
  //       let img = new Image();
  //       img.src = `${urlBase}/img/escudos/${pais.fifa_code}.png`;
  //       return img;
  //     })
  //   );
  //   images.concat([
  //     (() => {
  //       let img = new Image();
  //       img.src = `${urlBase}/img/escudos/escudoVacio.svg`;
  //       return img;
  //     })(),
  //     (() => {
  //       let img = new Image();
  //       img.src = `${urlBase}/img/banderas/banderaVacia.svg`;
  //       return img;
  //     })()
  //   ]);
  //   return images;
  // }

  handleUrlUpdate() {
    d3.json(`${this.state.urlBase}/data/data.json`, (error, datos) => {
      if (error) throw error;
      let maximos = datos.maximos;
      let paisesPorIso = {};
      let paises = datos.paises;
      let idsPartidos = datos.idsPartidos;
      for (let pais of datos.paises) {
        paisesPorIso[pais.iso_code] = pais;
      }
      let newState = { ...this.state };
      newState.datos = {
        paises: paises,
        paisesPorIso: paisesPorIso,
        maximos: maximos,
        idsPartidos: idsPartidos
      };
      newState.atributoSeleccionado = Object.keys(maximos)[0];
      // newState.images = this.preloadImages(this.state.urlBase, datos);
      this.setState(newState);
    });
    window.addEventListener('message', event => {
      // TODO authorize origin.
      let authorized = true;
      if (authorized) {
        let message = event.data;
        if (message.type === 'match') {
          this.handlePartidoChange(message.data);
        }
      }
    });
  }

  handlePartidoChange(partido) {
    const paises = this.state.datos.paises;
    const idsPartidos = this.state.datos.idsPartidos;
    if (!partido) {
      this.setState({ partido: null });
    } else {
      let dateStr = partido.date;
      let timeStr = partido.time;
      let hourStr = timeStr.slice(2);
      let hour = Number.parseInt(hourStr) + 5;
      let monthStr = dateStr.slice(-2);
      let month = monthStr === 'jn' ? 5 : 6;
      let day = Number.parseInt(dateStr.slice(-5).slice(0, 2), 10);
      let date = new Date(Date.UTC(2018, month, day, hour))
      let phase = Number.parseInt(partido.phase);
      let pais1Str = partido.team1.slice(-2).toUpperCase();
      let pais2Str = partido.team2.slice(-2).toUpperCase();
      let pais1 = null;
      let pais2 = null;
      for (let i = 0; i < paises.length; i++) {
        const pais = paises[i];
        if (pais.iso_code === pais1Str) {
          pais1 = pais;
        }
        if (pais.iso_code === pais2Str) {
          pais2 = pais;
        }
      }
      let idPartido = idsPartidos.filter(id => (
        (
          (id.iso1 === pais1Str && id.iso2 === pais2Str)
          || (id.iso1 === pais2Str && id.iso2 === pais1Str)
        ) && id.fase === phase
      ))[0];
      if (idPartido && pais1 && pais2 && date) {
        let newPartido = {
          fecha: date,
          pais1: pais1,
          pais2: pais2,
          id: idPartido.matchId.slice(1)
        };
        this.setState({ partido: newPartido });
      } else {
        this.setState({ partido: null });
      }
    }
  }

  handleAtributoChange(atributo) {
    const newState = { ...this.state };
    newState.atributoSeleccionado = atributo;
    this.setState(newState);
  }
  handleCapaChange(capa) {
    const newState = { ...this.state };
    newState.capaSeleccionada = capa;
    this.setState(newState);
  }

  SH4 = styled.h4`
    width: 100%;
    text-align: center;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  `;

  SFixedAspectRatio = (props, context) => {
    const SContainer = this.SFixedAspectRatioContainer;
    return <SContainer>{props.children}</SContainer>;
  };

  SFixedAspectRatioContainer = styled.div`
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    overflow: hidden;
  `;

  SIframe = styled.iframe`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    // max-height: 90vh;
    font-size: 24px;
    text-align: center;
  `;
  SButton = styled(Button)`
    background: #1c7ca2;
    border: none;
    padding: 0.1em;
    /* border: 2px solid #faca15; */
    border: 2px solid #125169;
    box-shadow: 0 0 0 #faca15;
    &:not(:disabled):not(.disabled):hover {
      border: 2px solid #faca15;
      background: #125169;
    }
    &:not(:disabled):not(.disabled):active:focus {
      border: 2px solid #faca15;
      background: #0e3d4f;
      box-shadow: 0 0 0 0.2rem rgba(250, 202, 21, 0.5);
    }
    &:not(:disabled):not(.disabled):active {
      border: 2px solid #faca15;
      background: #0e3d4f;
      box-shadow: 0 0 0 0.2rem rgba(250, 202, 21, 0.5);
    }
    &:not(:disabled):not(.disabled):focus {
      box-shadow: 0 0 0 0.2rem rgba(250, 202, 21, 0.5);
      /* box-shadow: 0 0 8px #faca15; */
    }
  `;
}



// WEBPACK FOOTER //
// ./src/componentes/VizCalendario.js